import React from 'react';
import { Box } from '@material-ui/core';
import Chart from 'react-apexcharts';
import GraphFilter from './GraphFilter';

function Graph({
  chartData = [],
  visibleReport,
  chartOptions,
  filterLoader,
  ...otherProps
}) {
  return (
    <>
      {chartData.map((item) => (
        <Box key={item.type} sx={{ mt: 3, mx: 3 }} dir="ltr">
          {item.type === visibleReport && (
            <>
              {!otherProps.isDashboard && (
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: 2
                  }}
                >
                  <GraphFilter
                    type={item.type}
                    handleFilter={item.filter}
                    filterLoader={filterLoader}
                  />
                </Box>
              )}
              <Chart
                // type="area"
                series={item?.data}
                options={chartOptions}
                height={580}
              />
            </>
          )}
        </Box>
      ))}
    </>
  );
}

export default Graph;
